import React from "react";
import { Link } from "react-router-dom";

/**
 * THE BASE AMENDMENT ID AS THE SHEET / YARDI SAID IT, THEN THE PARENT TCP HUNG
 * THE ROW OFF (Sim, 25 Sep 2026): "949494 (TCP-4353708)", the resolved one
 * muted.
 *
 * `stated_base_amendment_id` is the payload's own BaseAmendmentID (read from the
 * amendment's `meta` by AmendmentSerializer); `base_amendment_id` is the
 * resolved parent, which is a seed's "TCP-…" id when a seed's AmendmentID list
 * answered for it (Amendment::Ingestor#effective_base_id). The two only differ
 * in that case; otherwise one id is shown. A row whose payload said nothing (a
 * seed, an older record) shows the resolved id alone.
 */
export const baseIds = (amendment: tcpinpoint.Amendment) => {
	const said = amendment.stated_base_amendment_id || null;
	const resolved = amendment.base_amendment_id || null;
	const shown = said || resolved;
	const alias = !!said && !!resolved && said !== resolved ? resolved : null;
	return { shown, alias };
};

/** Plain text, for a place that cannot style part of the value (a locked input). */
export const baseText = (amendment: tcpinpoint.Amendment) => {
	const { shown, alias } = baseIds(amendment);
	if (!shown) return null;
	return alias ? `${shown} (${alias})` : shown;
};

/**
 * The styled form. Renders nothing when there is no base at all.
 *
 * `linked` makes the resolved "TCP-…" id a link to that amendment (Sim, 25 Sep
 * 2026). Off where the whole row is already a link (the Amendments list) — an
 * anchor inside an anchor is invalid HTML and the inner one would never get the
 * click.
 */
const StatedBase = ({
	amendment,
	prefix = "",
	linked = false
}: {
	amendment: tcpinpoint.Amendment;
	prefix?: string;
	linked?: boolean;
}) => {
	const { shown, alias } = baseIds(amendment);
	if (!shown) return null;
	const target =
		linked && !!amendment.base_amendment_record_id && !!amendment.lease_agreement_id
			? `/lease-agreements/${amendment.lease_agreement_id}/amendments/${amendment.base_amendment_record_id}`
			: null;
	return (
		<>
			{prefix}
			{shown}
			{!!alias && (
				<span className="muted">
					{" ("}
					{/* `color: inherit` keeps the link the SAME grey as its brackets — the
					    global anchor colour otherwise wins over `.muted`. Still underlined
					    on hover, so it reads as clickable. */}
					{target ? (
						<Link to={target} style={{ color: "inherit" }}>
							{alias}
						</Link>
					) : (
						alias
					)}
					{")"}
				</span>
			)}
		</>
	);
};

export default StatedBase;
